import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const SettingsView = lazy(() => import('./SettingsView'));

const route: FuseRouteItemType = {
	path: 'settings',
	element: <SettingsView />
};

export default route;
